import { render, staticRenderFns } from "./Vnda.vue?vue&type=template&id=62a8a830"
import script from "./Vnda.vue?vue&type=script&lang=js"
export * from "./Vnda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports